<button class="home-play-button" [ngStyle]="overlayStyles"></button>
